import { css } from 'aphrodite';
import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { MastheadPortalId } from '../../../models/AdminModels';
import { IUserSessionComponentProps, UserSessionViewModelKey } from '../../../models/AppState';
import { PortalDestination } from '../../../web/components/Portal';
import { UserProfileNav } from '../../../web/components/UserProfileNav';
import { SupportNotificationsBell } from '../supportShared/SupportNotificationsBell';
import { styleSheet } from './styles';

interface IProps extends RouteComponentProps<any>, IUserSessionComponentProps {
	className?: string;
	height?: number;
	navigationFillsSpace?: boolean;
	showDivider?: boolean;
}

class _Masthead extends React.Component<IProps> {
	public render() {
		const { className, height, navigationFillsSpace = false, showDivider = true, ...restProps } = this.props;
		const heightStyle = height === undefined ? undefined : { height, minHeight: height };
		return (
			<div className={`masthead ${css(styleSheet.container)} ${className || ''}`} style={heightStyle}>
				<div
					className={`masthead-content ${css(styleSheet.content, !showDivider && styleSheet.contentWithoutDivider)}`}
					style={heightStyle}
				>
					<div
						className={`masthead-navigation-item ${css(
							styleSheet.navItem,
							navigationFillsSpace && styleSheet.navItemFill
						)}`}
					>
						<PortalDestination id={MastheadPortalId} />
					</div>
					<SupportNotificationsBell />
					<UserProfileNav isAdminPage={true} {...restProps} />
				</div>
			</div>
		);
	}
}

const MastheadWithRouter = withRouter(_Masthead);
export const Masthead = inject(UserSessionViewModelKey)(MastheadWithRouter);
